export const GET_GELATINS = 'GET_GELATINS';
export const GET_GELATIN_BY_ID = 'GET_GELATIN_BY_ID';
export const UPDATE_GELATIN = 'UPDATE_GELATIN';
export const DELETE_GELATIN = 'DELETE_GELATIN';
export const CREATE_GELATIN = 'CREATE_GELATIN';
